import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en/translations.json';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en'],
    resources: {
      en: {
        translation: enTranslations,
      },
    },

    // CI Mode is useful for rendering i18n keys instead of text:
    appendNamespaceToCIMode: import.meta.env.DEV,

    // Allows 'en-US' and 'en-UK' to be implicitly supported when 'en' is supported
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },

    // debug: process.env.NODE_ENV === 'development',

    detection: {
      order: ['localStorage', 'navigator'],
      excludeCacheFor: ['cimode'],
    },
  });

export default i18next;
